import React from "react";
import { getField } from "../../util/DynamicItemUtils";

export default function GlobalNetwork({ item }: any) {
  const href = "/oversight/registration/global-network-firms";
  const finalHref = `${href}?globalnetwork=${encodeURIComponent(
    getField(item, "title")
  )}`;

  return (
    <div>
      <p className="lead-text-lt">Global Network</p>
      <h3>
        <a href={finalHref}>{getField(item, "title")}</a>
      </h3>
      <a href={finalHref} className="hawk-read-more">
        View Global Network Firms
      </a>
    </div>
  );
}
